const SITE_ARI_REGEX = new RegExp('ari:cloud:(.+)::site/(.+)');

/**
 * This util should not throw error and should resolve to defaults for invalid input.
 *
 * @param ari
 * @returns product and id from the ari
 */
export const parseSiteARI: (ari: string) => {
    product: string;
    id: string;
} = (ari: string) => {
	if (!ari) {
		return { product: '', id: '' };
	}

	const [_original, product, id] = Array.from(ari.match(SITE_ARI_REGEX) || ['', '', '']);

	return {
		product,
		id,
	};
};
